/* eslint-disable */


import { NAVBAR_MENU_WIDTH } from '../../Constants/Navbar/Navbar.constants';
import * as themeConstants from '../../Constants/Theme/Theme.constants';

/**
 * Create styles for `<Navbar />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<Navbar />` styles
 */
const navbarStyles = ({ isLight, theme }) => ({
  activeIcon: {
    color: themeConstants.BORAL_GREEN,
  },
  appBar: {
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.shadows[0],
    zIndex: theme.zIndex.drawer + 1,
  },
  appsMenu: {},
  addIcon: {
    marginRight: theme.spacing(1),
  },
  burgerButton: {
    left: theme.spacing(1),
    marginRight: theme.spacing(1) * 2,
    position: `absolute`,
    top: theme.spacing(1),
  },
  extensions: {
    marginRight: theme.spacing(1) * 2,
    position: `absolute`,
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  headingIndent: {
    marginRight: theme.spacing(1) * 2,
  },
  largeNavBar: {
    minHeight: 208,
    paddingLeft: theme.spacing(1) * 3,
    paddingRight: theme.spacing(1) * 3,
  },
  largePadding: {
    paddingLeft: theme.spacing(1) * 9,
  },
  logo: {
    display: `block`,
    marginRight: theme.spacing(1),
    maxHeight: `32px`,
  },
  menuButton: {
    marginRight: theme.spacing(1),
  },
  menuWidth: {
    maxWidth: NAVBAR_MENU_WIDTH,
    width: `calc(100vw - ${theme.spacing(1) * 2 * 2}px)`,
  },
  offset: {
    ...theme.mixins.toolbar,
  },
  root: {
    [theme.breakpoints.up(`md`)]: {
      position: `relative`,
    },
  },
  secondaryAction: {
    color: theme.palette.text.primary,
  },
  smallPadding: {
    paddingLeft: theme.spacing(1),
  },
  userMenu: {},
  paperClasses: {
    minWidth: 600,
  },
  settingsButton: {
    marginLeft: theme.spacing(1),
  }
});

export default navbarStyles;
